import { ChangeDetectorRef, Component, OnInit, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DocumentViewerService, DocumentViewerResult } from '../../../service/document-viewer.service';

interface AttachmentData {
  attachment: any;
}

@Component({
  selector: 'app-attachment-viewer',
  templateUrl: './attachment-viewer.component.html',
  styleUrls: ['./attachment-viewer.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class AttachmentViewerComponent implements OnInit {
  private documentViewerService = inject(DocumentViewerService);
  /** Zoneless: a post-`await` assignment must notify Angular explicitly. */
  private cdrZoneless = inject(ChangeDetectorRef);
  private router = inject(Router);
  private dialogRef = inject(MatDialogRef<AttachmentViewerComponent>);
  
  currentAttachment: any = null;
  currentDocument: DocumentViewerResult | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AttachmentData) { 
    if (data && data.attachment) {
      this.currentAttachment = data.attachment;
    }
  }

  async ngOnInit(): Promise<void> {
    if (this.currentAttachment) {
      const attachmentInput = this.currentAttachment.attachmentData || this.currentAttachment;
      console.log('[AttachmentViewer] Raw attachment:', this.currentAttachment);
      console.log('[AttachmentViewer] Input to processDocument:', attachmentInput);
      console.log('[AttachmentViewer] directLink:', attachmentInput?.directLink);
      console.log('[AttachmentViewer] s3filename:', attachmentInput?.s3filename);
      console.log('[AttachmentViewer] originalFileName:', attachmentInput?.originalFileName);

      // Process attachment using the service
      this.currentDocument = await this.documentViewerService.processDocument(attachmentInput);
      this.cdrZoneless.markForCheck();   // zoneless: notify after await
      console.log('[AttachmentViewer] Processed result:', this.currentDocument);
      console.log('[AttachmentViewer] Final directLink:', this.currentDocument?.directLink);
      console.log('[AttachmentViewer] Resolved s3Key:', this.currentDocument?.s3Key);
    }
  }

  async downloadAttachment(): Promise<void> {
    if (this.currentDocument) {
      // Re-mint first: this dialog may have been open longer than the ~15 min presign TTL,
      // and fetchUrl (not directLink) is the only url that resolves against a private bucket.
      this.currentDocument = await this.documentViewerService.refreshFetchUrl(this.currentDocument);
      this.documentViewerService.downloadFile(
        this.currentDocument.fetchUrl,
        this.currentDocument.fileName
      );
    }
  }

  async openInNewTab(): Promise<void> {
    if (this.currentDocument) {
      this.currentDocument = await this.documentViewerService.refreshFetchUrl(this.currentDocument);
      this.documentViewerService.openInNewTab(this.currentDocument.fetchUrl);
    }
  }

  openContractWithAttachment(contractNumber: string): void {
    this.dialogRef.close();
    this.router.navigate(['/securehome/contract', contractNumber]);
  }

  openCoiWithAttachment(coiNumber: string): void {
    this.dialogRef.close();
    this.router.navigate(['/securehome/coi', coiNumber]);
  }

  openBaaWithAttachment(baaNumber: string): void {
    this.dialogRef.close();
    this.router.navigate(['/securehome/baa', baaNumber]);
  }
 
  openPersonWithAttachment(personNumber: string): void {
    this.dialogRef.close();
    // this.router.navigate(['/securehome/contact', personNumber]);
  }

  openPartyWithAttachment(partyNumber: string): void {
    this.dialogRef.close();
    this.router.navigate(['/securehome/vendor', partyNumber]);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}